export enum Roles {
  Admin = 'admin',
  User = 'user'
}

export interface MeResponse {
  id: string;
  email: string;
  role: Roles;
  exp: number;
  iat: number;
}

export interface IdentityState {
  initialized: boolean;
  user: MeResponse | undefined;
}

export const getDefaultIdentityState = (): IdentityState => {
  return {
    initialized: false,
    user: undefined,
  };
};
